/** Resident car available statuses */
export enum ResidentCarStatusEnum {
  /** The car drove in */
  DROVE_IN = 'DROVE_IN',
  /** The car drove out */
  DROVE_OUT = 'DROVE_OUT',
}
